export enum CategoryL1 {
  Finance = 'Finance',
  OnlineBuying = 'Online Buying',
  Contact= 'Contact'
}

export enum CategoryL2 {
  Application = 'Application',
  PreQual = 'Prequal',
  PersonalDetails = 'Personal Details',
  OEM = 'OEM Referral'
}

export enum CategoryL3 {
  Personal = 'Personal',
  Residence = 'Residence',
  Residence2 = 'Residence 2',
  Employment = 'Employment',
  Employment2 = 'Employment 2',
  AdditionalIncome = 'Additional Income',
  Review = 'Review',
  Unlock = 'Unlock',
  CreditApplicationsModal = 'Credit Applications Modal',
  Confirmation = 'Confirmation',
  BuyNowPersonal = 'Personal Information',
  BuyNowResidence = 'Residence Information',
  BuyNowResidence2 = 'Residence Information 2',
  BuyNowEmployment = 'Employment Information',
  BuyNowEmployment2 = 'Employment Information 2',
  BuyNowAdditionalIncome = 'Additional Information',
  BuyNowReview = 'Review Information',
  BuyNowUnlock = 'Unlock',
  BuyNowConfirmation = 'Confirmation',
  Prequal = 'Prequal',
}

export enum CategoryL4 {
  Primary = 'Primary',
  Cobuyer = 'Cobuyer',
  Confirmation = 'Confirmation'
}

export enum FormName {
  PreQualForm = 'prequal_form',
  PersonalDetails = 'personal_details',
  OEMReferral = 'oem_referral'
}

export enum FormActualName {
  CreditAppPersonal = 'credit-app-personal',
  CreditAppResidence = 'credit-app-residence',
  CreditAppResidence2 = 'credit-app-residence-2',
  CreditAppEmployment = 'credit-app-employment',
  CreditAppEmployment2 = 'credit-app-employment-2',
  CreditAppAdditionalIncome = 'credit-app-additional-income',
  CreditAppPersonalCobuyer = 'credit-app-personal-cobuyer',
  CreditAppResidenceCobuyer = 'credit-app-residence-cobuyer',
  CreditAppResidenceCobuyer2 = 'credit-app-residence-cobuyer-2',
  CreditAppEmploymentCobuyer = 'credit-app-employment-cobuyer',
  CreditAppEmploymentCobuyer2 = 'credit-app-employment-cobuyer-2',
  CreditAppAdditionalIncomeCobuyer = 'credit-app-additional-income-cobuyer',
  CreditAppReview = 'credit-app-review',
  CreditAppConfirm = 'credit-app-confirm',
  PreQualForm = 'prequal-form',
  PersonalDetails = 'personal-details',
  vdpPrequalification = "VDP -Pre Qualification",
  OEMContact = "oem-contact"
}

export enum FormNumber {
  PersonalInfo = 1,
  ResidenceInfo = 2,
  PreviousResidenceInfo = 3,
  EmploymentInfo = 4,
  PreviousEmploymentInfo = 5,
  AdditionalInfo = 6,
  CoBuyerPersonalInfo = 7,
  CoBuyerResidenceInfo = 8,
  CoBuyerPreviousResidenceInfo = 9,
  CoBuyerEmploymentInfo = 10,
  CoBuyerPreviousEmploymentInfo = 11,
  CoBuyerAdditionalInfo = 12,
  ReviewInfo = 13,
  Confirmation = 14
}

export enum EventLabel {
  CreditApplicationFormLoad = 'Credit Application-Form Load',
  CreditApplicationFormStarted = 'Credit Application-Form Started',
  CreditApplicationSubmitInitiated = 'Credit Application-Submit Initiated',
  CreditApplicationSubmitSuccess = 'Credit Application-Submit Success',
  CreditApplicationSubmitFailure = 'Credit Application-Submit Failure',
  EditPersonalInfo = 'Edit Personal Info',
  EditResidenceInfo = 'Edit Residence Info',
  EditEmploymentInfo = 'Edit Employment Info',
  EditAdditionalInfo = 'Edit Additional Info',
  EditCobuyerPersonalInfo = 'Edit Cobuyer Personal Info',
  EditCobuyerResidenceInfo = 'Edit Cobuyer Residence Info',
  EditCobuyerEmploymentInfo = 'Edit Cobuyer Employment Info',
  EditCobuyerAdditionalInfo = 'Edit Cobuyer Additional Info',
  SubmitApplication = 'Submit Application',
  UnlockCreditApp = 'Unlock Credit App',
  CreateNewCreditApp = 'Create New Credit App',
  MapClick = 'Map Click',
  PreQualFormLoad = 'Prequal-Form Load',
  PreQualFormStarted = 'Prequal-Form Started',
  PreQualFormSubmitInitiated = 'Prequal-Submit Initiated',
  PreQualFormSuccess = 'Prequal-Form Success',
  PreQualLeadSubmission = 'Prequal-Lead Submission',
  PreQualFormFailure = 'Prequal-Form Failure',
  PersonalDetailsPageLoad = 'Personal Details-Page Load',
  PersonalDetailsFormLoad = 'Personal Details-Form Load',
  SelectDelivery = 'Select Delivery',
  SelectPreQualify = 'Select Pre Qualify',
  PersonalDetailsPrequalPageLoad = 'Personal Details Prequal-Page Load',
  PersonalDetailsFormStarted = 'Personal Details-Form Started',
  PersonalDetailsFormSuccess = 'Personal Details-Form Success',
  PersonalDetailsFormFailure = 'Personal Details-Form Failure',
  PersonalDetailsSubmitInitiated = 'Personal Details-Submit Initiated',
  PersonalDetailsLeadSubmission = 'Personal Details-Lead Submission',
  FinanceApplicationFormLoad = 'Finance Application-Form Load',
  FinanceApplicationSubmitInitiated = 'Finance Application-Submit Initiated',
  FinanceApplicationFormStarted = 'Finance Application-Form Started',
  FinanceApplicationFormSuccess = 'Finance Application-Form Success',
  FinanceApplicationFormFailure = 'Finance Application-Form Failure',
  PrequalApproved = 'Prequal-Approved Amount',
  PrequalDenied = 'Prequal-Denied Amount',

}

export enum FormAndProcessActualName {
  FinancePersonal = 'finance-personal',
  FinanceResidence = 'finance-residence',
  FinanceResidence2 = 'finance-residence-2',
  FinanceEmployment = 'finance-employment',
  FinanceEmployment2 = 'finance-employment-2',
  AdditionIncome = 'finance-additional',
  FinanceCobuyerPersonal = 'finance-cobuyer-personal',
  AdditionCobuyerIncome = 'finance-cobuyer-additional',
  FinanceCobuyerResidence = 'finance-cobuyer-residence',
  FinanceCobuyerResidence2 = 'finance-cobuyer-residence-2',
  FinanceCobuyerEmployment = 'finance-cobuyer-employment',
  FinanceCobuyerEmployment2 = 'finance-cobuyer-employment-2',
  FinanceReview = 'finance-review',
}
export enum EditEvent {
  EditPersonalInfo = 'edit personal info',
  EditResidenceInfo = 'edit residence info',
  EditEmploymentInfo = 'edit employment info',
  EditAdditionalInfo = 'edit additional info',
  EditCobuyerPersonalInfo = 'edit cobuyer personal info',
  EditCobuyerResidenceInfo = 'edit cobuyer residence info',
  EditCobuyerEmploymentInfo = 'edit cobuyer employment info',
  EditCobuyerAdditionalInfo = 'edit cobuyer additional info',
  SubmitApplication = 'submit application',
  UnlockCreditApp = 'unlock credit app',
  CreateNewCreditApp = 'create new credit app',
  CallButton = 'call_button',
  MapClick = 'map_click',
  PageLoad = 'page_load',
  FormLoad = 'form_load',
  FormStarted = 'form_started',
  FormSubmitInitiated = 'submit_initiated',
  FormSuccess = 'form_success',
  LeadSubmission = 'lead_submission',
  FormFailure = 'form_failure',
  SelectDelivery = 'select_delivery',
  SelectPrequalify = 'select_prequalify',
  ApprovedPrequal = 'approved_prequal',
  DeclinedPrequal = 'denied_prequal'
}

export enum EventCategory {
  LeadSubmission = 'Lead Submission',
  EngagementType = 'EngagementType'
}

export enum EventAction {
  LeadSubmission = 'Lead Submission_Finance|||_Credit Application',
  LeadSubmissionPreQualFormLoad = 'Lead Submission_Prequal|||Form_Load',
  EngagementType = 'EngagementType_Link_Finance|||click',
  EngagementTypePrequalPhone = 'EngagementType_Prequal|||Phone',
  EngagementTypePrequalFormLoad = 'Lead Submission_Prequal|||Form_Load',
  EngagementTypePrequalFormStarted = 'Lead Submission_Prequal|||Form_Started',
  EngagementTypePrequalFormSubmitInitiated = 'Lead Submission_Prequal|||Submit_Initiated',
  EngagementTypePrequalFormSuccess = 'Lead Submission_Prequal|||Form_Success',
  EngagementTypePrequalLeadSubmission = 'Lead Submission_Prequal|||Lead_Submission',
  EngagementTypePrequalLeadFailure = 'Lead Submission_Prequal|||Form_Failure',
  EngagementTypeDigitalRetailingClick = 'EngagementType_Digital Retailing|||Click',
  EngagementTypeDigitalRetailingLeadSubmissionInitiated = 'Lead Submission_Digital Retailing|||Submit_Initiated',
  EngagementTypeDigitalRetailingFormSuccess = 'Lead Submission_Digital Retailing|||Form_Success',
  EngagementTypeDigitalRetailingFormFailure = 'Lead Submission_Digital Retailing|||Form_Failure',
  LeadSubmissionDigitalRetailingPageLoad = 'Lead Submission_Digital Retailing|||Page_Load',
  LeadSubmissionDigitalRetailingFormLoad = 'Lead Submission_Digital Retailing|||Form_Load',
  LeadSubmissionDigitalRetailingFormStarted = 'Lead Submission_Digital Retailing|||Form_Started',
  LeadSubmissionDigitalRetailingSubmitInitiated = 'Lead Submission_Digital Retailing|||Submit_Initiated',
  LeadSubmissionDigitalRetailingLeadSubmission = 'Lead Submission_Digital Retailing|||Lead_Submission',
  LeadSubmissionDigitalRetailingFormSuccess = 'Lead Submission_Digital Retailing|||Form_Success',
  LeadSubmissionDigitalRetailingFormFailure = 'Lead Submission_Digital Retailing|||Form_Failure',
  EngagementTypePrequalApproved = 'Lead Submission_Prequal|||Approved',
  EngagementTypePrequalDenied = 'Lead Submission_Prequal|||Denied'

}

export enum CreditAppUDOConstants {
  ProcessActualName = 'credit_app_instore',
  ProcessName = 'finance',
}

export enum PersonalDetailsUDOConstants {
  ProcessName = 'digital_retailing',
  ProcessActualName = 'personal-details',
}

export enum PersonalDetailsPrequalUDOConstants {
  ProcessName = 'digital_retailing',
  ProcessActualName = 'personal-details-prequal',
}

export enum UDOConstant {
  UnityFlag = '1',
  LeadProviderID = 'AutoNation.com',
  ServiceUnavailable = 'Service Unavailable',
  ErrorCode = 503,
  preQualPageGroup = 'prequal',
  personalDetailsPageGroup = 'personal_details',
  DigitalRetailing = 'digital_retailing',
  Checkout = 'checkout',
  FinanceApplicationPageGroup = 'finance_application'
}

export enum ErrorType {
  CreditAppNotSaved = 'Credit App Not Saved',
  CreditAppNotSubmitted = 'Credit App Not Submitted',
  CreditAppNotLoaded = 'Credit Apps Not Loaded',
  GeneralError = 'Credit App Error'
}


export enum PreQualFormEventConstant {
  FormStarted = 'Form Started',
  FormSubmitInitiated = 'Submit Initiated',
  FormSuccess = 'Form Success',
  LeadSubmission = 'Lead Submission',
  FormFailure = 'Form Failure',
  FormLoad = 'PrequalFormLoad',
  SelectHomeDelivery = 'SelectHomeDelivery',
  SelectPrequalify = 'SelectPrequalify',
  PreQualApproved = 'PreQualApproved',
  PreQualDeclined = 'PreQualDeclined',
  PreQualConfirmationLoaded = 'PrequalConfirmationLoad',
  PreQualConfirmationClose = 'PreQualConfirmationClose'
}


export enum DynamicYieldEventName {
  AddToCart = 'Add to Cart',
  FormLoadPersonalDetails = 'Form Load Personal Details',
  FormLoadVDPPreQual = 'Form Load VDP -Pre Qualification',
  FormSuccessPersonalDetails = 'Form Success Personal Details',
  FormSuccessVDPPrequal = 'Form Success VDP -Pre Qualification',
  Purchase = 'Purchase',
  FormLoadCreditApplication = 'Form Load Credit Application',
  FormSuccessCreditApplication = 'Form Success Credit Application',
  FormStartPersonalDetails = 'Form Start Personal Details',
  FormStartVDPPrequal = 'Form Start VDP -Pre Qualification',
  PrequalModalAddToCart = 'PrequalModalAddToCart',
  PrequalModalFormLoad = 'PrequalModalFormLoad',
  PrequalModalFormStart = 'PreQualModalFormStart',
  PrequalModalFormSubmit = 'PrequalModalFormSubmit',
  PrequalModalFormSuccess = 'PrequalModalFormSuccess',
  PrequalModalFormFailure = 'PrequalModalFormFailure',
  PrequalModalPurchase = 'PrequalModalPurchase'
}

export enum vehicle_Info{
  vehic_list ='vdp',
  vehic_position = 1,
  vehic_quantity = 1
}

export enum checkout_Info{
  buyNow_checkout_option = 'ANPurchase',
  buyNow_checkout_step = 'VDP Calculator',
  enh_action_add = 'add',
  enh_action_checkout = 'checkout'
}
